import COUNTRIES from '../countries.translations'

import { articleFigure } from './articleFigure'
import { articleMetal } from './articleMetal'
import translations from './story05.content'
import type { Article } from './types'

const t = translations
const dir = '/mine-my-phone/images/articles/story05'
const figure = articleFigure(dir)

export const story05: Article = {
  id: 5,
  slug: 'capturing-tin-workers-on-bangka-island',
  order: 5,
  title: t.title,
  excerpt: t.excerpt,
  // The doc names no hero, so the card reuses the first photograph.
  image: `${dir}/01.jpg`,
  imageCaption: [t.credit],
  metal: articleMetal('tin'),
  author: 'Hannah J Davies',
  // Same coordinates as the tin sheet's Bangka pin, so story and mine land together.
  region: [
    {
      name: t.regionName,
      country: COUNTRIES.indonesia,
      coordinates: [106.1, -2.3],
      impact: 'environmental',
    },
  ],
  impactList: ['environmental', 'human'],
  content: {
    sections: [
      { type: 'prose', blocks: [...t.prose[0]] },
      figure('01.jpg', [t.credit]), // CAPTION 1 — the abandoned pit
      { type: 'prose', blocks: [...t.prose[1]] },
      figure('02.jpg', [t.credit]), // CAPTION 2 — eight hours in the slurry
      { type: 'prose', blocks: [...t.prose[2]] },
      figure('03.jpg', [t.credit]), // CAPTION 3 — Alfonso, the trader
      { type: 'prose', blocks: [...t.prose[3]] },
      figure('04.jpg', [t.credit]), // CAPTION 4 — Ikrane, 13
      { type: 'prose', blocks: [...t.prose[4]] },
      figure('05.jpg', [t.credit]), // CAPTION 5 — the Martian ground
      { type: 'prose', blocks: [...t.prose[5]] },
    ],
  },
}
